(() => {
  const key = 'kindgut-daily-balance-offer-seen-v1';
  const initialize = scope => {
    scope.querySelectorAll('[data-kg-free-gift]').forEach(dialog => {
      if (dialog.dataset.kgReady) return;
      dialog.dataset.kgReady = 'true';
      const root = dialog.closest('[data-pc-bp]');
      if (!root) return;
      const controller = new AbortController();
      let checkoutStarted = false;
      let timer;
      let previousFocus;
      let previousOverflow;
      const open = () => {
        if (dialog.open || !dialog.isConnected) return;
        previousFocus = document.activeElement;
        previousOverflow = document.documentElement.style.overflow;
        dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      };
      dialog.kindgutPreview = open;
      dialog.kindgutCleanup = () => { clearTimeout(timer); if (dialog.open) dialog.close(); controller.abort(); };
      root.addEventListener('click', event => {
        if (!event.target.closest('[data-kindgut-purchase]')) return;
        checkoutStarted = true;
        clearTimeout(timer);
      }, { capture: true, signal: controller.signal });
      dialog.querySelectorAll('[data-kg-free-gift-close]').forEach(button => button.addEventListener('click', () => dialog.close(), { signal: controller.signal }));
      dialog.addEventListener('close', () => {
        if (previousOverflow !== undefined) document.documentElement.style.overflow = previousOverflow;
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }, { signal: controller.signal });
      const tryShow = () => {
        if (checkoutStarted || !dialog.isConnected || dialog.dataset.enabled === 'false') return;
        try { if (localStorage.getItem(key)) return; } catch (_) { return; }
        const active = document.activeElement;
        const busy = document.hidden || document.querySelector('dialog[open], .hbo-modal.is-open, .hbo-dpop:not([hidden]), .hbo-lb.is-open') || active?.matches('input, textarea, select, [contenteditable="true"]');
        if (busy) { timer = setTimeout(tryShow, 1000); return; }
        open();
        try { localStorage.setItem(key, '1'); } catch (_) { dialog.close(); }
      };
      if (!window.Shopify?.designMode) timer = setTimeout(tryShow, Number(dialog.dataset.delay || 10) * 1000);
      window.addEventListener('pagehide', () => dialog.kindgutCleanup(), { once: true, signal: controller.signal });
    });
  };
  const start = () => initialize(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true }); else start();
  if (window.kindgutGiftEditorReady) return;
  window.kindgutGiftEditorReady = true;
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('[data-kg-free-gift]').forEach(dialog => dialog.kindgutCleanup?.()));
  document.addEventListener('shopify:section:select', event => event.target.querySelector('[data-kg-free-gift]')?.kindgutPreview?.());
  document.addEventListener('shopify:section:deselect', event => event.target.querySelector('[data-kg-free-gift][open]')?.close());
})();
